var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-alt-circle-left-solid copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    stroke: "none",
    strokeWidth: 1,
    fill: "inherit",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-SE-(Individual-Work)-Copy",
    transform: "translate(-129.000000, -515.000000)",
    fillRule: "nonzero",
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-alt-circle-left-solid-copy",
    transform: "translate(129.000000, 515.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,16 C3.58064516,16 0,12.4193548 0,8 C0,3.58064516 3.58064516,0 8,0 C12.4193548,0 16,3.58064516 16,8 C16,12.4193548 12.4193548,16 8,16 Z M11.7419355,6.58064516 L8,6.58064516 L8,4.29354839 C8,3.9483871 7.58064516,3.77419355 7.33870968,4.01935484 L3.6516129,7.72580645 C3.5,7.87741935 3.5,8.11935484 3.6516129,8.27096774 L7.33870968,11.9774194 C7.58387097,12.2225806 8,12.0483871 8,11.7032258 L8,9.41935484 L11.7419355,9.41935484 C11.9548387,9.41935484 12.1290323,9.24516129 12.1290323,9.03225806 L12.1290323,6.96774194 C12.1290323,6.75483871 11.9548387,6.58064516 11.7419355,6.58064516 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.fa8a25870788fde9a972906ec69e526d.svg";
export { ForwardRef as ReactComponent };